module.exports = __webpack_public_path__ + "static/img/wechat_shouquanshuoming.ac704cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/official/wechat_shouquanshuoming.png
// module id = b0B+
// module chunks = 0